import type { ReactNode } from 'react';
import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
  title: string;
  eyebrow?: string;
  right?: ReactNode;
}

export function SectionHeader({ title, eyebrow, right }: SectionHeaderProps) {
  return (
    <div className={styles.header}>
      <div>
        {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}
        <h2>{title}</h2>
      </div>
      {right && <div className={styles.right}>{right}</div>}
    </div>
  );
}
